import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const WebViewDetector = () => {
    const history = useHistory();
    const location = useLocation();

    // Função para detectar WebView REAL (apenas Flutter autêntico)
    const detectRealWebView = () => {
        // 1. Verificar User-Agent customizado (AgrareApp)
        const hasCustomUserAgent = /AgrareApp/i.test(navigator.userAgent);

        // 2. Verificação padrão de WebView (Android e iOS)
        const isWebViewUserAgent = /WebView|wv/i.test(navigator.userAgent);

        // 3. Verificar objeto do Flutter InAppWebView
        const hasFlutterInAppWebView = window.flutter_inappwebview !== undefined;

        // 4. SEGURANÇA: Verificar APENAS meta tags (não window.__WEBVIEW_HEADERS__)
        const hasWebViewHeaders = document.querySelector('meta[name="webview-auth"]');

        // Retornar true APENAS se pelo menos uma evidência forte de WebView Flutter
        return hasCustomUserAgent || isWebViewUserAgent || hasFlutterInAppWebView || hasWebViewHeaders;
    };

    const detectWebView = () => {
        // SEGURANÇA: Verificar APENAS meta tags (não window.__WEBVIEW_HEADERS__)
        const authMeta = document.querySelector('meta[name="webview-auth"]');
        const sourceMeta = document.querySelector('meta[name="webview-source"]');

        if (authMeta && sourceMeta) {
            return true;
        }

        // Verificar User Agent para Flutter WebView
        const userAgent = navigator.userAgent || window.opera;
        if (/AgrareApp/i.test(userAgent) || /Flutter/i.test(userAgent)) {
            return true;
        }

        // Verificar objeto Flutter InAppWebView
        if (window.flutter_inappwebview !== undefined) {
            return true;
        }

        // Verificar se está em um contexto que parece WebView
        // IMPORTANTE: Não usar 'Version/' + 'Mobile' pois Safari Mobile tem esses dois
        try {
            // WebViews Android geralmente têm 'wv' no User-Agent
            if (userAgent.includes('wv')) {
                return true;
            }
        } catch (e) {
            // Se houver erro acessando userAgent, não assumir como WebView
        }

        return false;
    };

    useEffect(() => {
        const isWebViewAuthPage = location.pathname === '/webview-auth';

        // PROTEÇÃO: Bloquear acesso à rota /webview-auth se NÃO estiver em um WebView real
        if (isWebViewAuthPage) {
            const isRealWebView = detectRealWebView();

            if (!isRealWebView) {
                // console.error('🚫 Acesso bloqueado: rota /webview-auth disponível apenas via Flutter WebView');
                history.replace('/login');
                return;
            }

            return; // Permitir navegação para /webview-auth
        }

        // Verificar se está rodando em WebView para outras rotas
        const isWebView = detectWebView();

        // Permitir bypass do WebView se estiver em rotas específicas ou com parâmetro
        const urlParams = new URLSearchParams(window.location.search);
        const forceWebLogin = urlParams.get('web_login') === 'true';
        const isLoginPage = location.pathname === '/login';

        // Não redirecionar se:
        // 1. Está forçando login web
        // 2. Está na página de login e não há indicação clara de WebView real
        if (isWebView && !forceWebLogin) {
            // Se está na página de login, só redirecionar se há evidência forte de WebView
            if (isLoginPage) {
                // SEGURANÇA: Só redirecionar se há meta tags (não window.__WEBVIEW_HEADERS__)
                const hasRealWebViewHeaders = document.querySelector('meta[name="webview-auth"]');

                if (!hasRealWebViewHeaders) {
                    return;
                }
            }

            // Verificar se já tem token na sessão (usando sessionStorage)
            const existingToken = sessionStorage.getItem('agrare-security-token');
            const existingUser = sessionStorage.getItem('agrare-security-user');

            if (!existingToken || !existingUser) {
                history.replace('/webview-auth');
            }
        }
    }, [history, location.pathname]);

    return null; // Este componente não renderiza nada
};

export default WebViewDetector;